import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  tests: null,
  fetchingDropdown: false,
  commodityCategories: null,
  testCategories: null,
  commodities: null,
  dropdowns: null,
};

const addTestSlice = createSlice({
  name: "addTest",
  initialState,
  reducers: {
    fetchCommodityCategories(state, action) {
      state.loading = true;
    },
    fetchCommodityCategoriesSuccess(state, action) {
      state.commodityCategories = action.payload.data.document;
      state.loading = false;
    },
    fetchCommodityCategoriesFailure(state, action) {
      state.loading = false;
    },
    fetchTestCategories(state, action) {
      state.loading = true;
    },
    fetchTestCategoriesSuccess(state, action) {
      state.testCategories = action.payload.data.document;
      state.loading = false;
    },
    fetchTestCategoriesFailure(state, action) {
      state.loading = false;
    },

    fetchCommodities(state, action) {
      state.loading = true;
    },
    fetchCommoditiesSuccess(state, action) {
      state.commodities = action.payload.data.document;
      state.loading = false;
    },
    fetchCommoditiesFailure(state, action) {
      state.loading = false;
    },
    addTest(state, action) {
      state.loading = true;
    },
    addTestSuccess(state, action) {
      state.loading = false;
    },
    addTestFailure(state, action) {
      state.loading = false;
      state.error = action.payload.message;
    },
    initializeError(state, action) {
      state.error = null;
    },
    fetchDropdown(state, action) {
      state.fetchingDropdown = true;
    },
    fetchDropdownSuccess(state, action) {
      state.fetchingDropdown = false;
      state.dropdowns = action.payload.data.document;
    },
    fetchDropdownFailure(state, action) {
      state.fetchingDropdown = false;
    },
  },
});

export const { actions, reducer, name: sliceKey } = addTestSlice;
